<template>
    <div class="page-padding">
        <TechnologyAssetsComparisonTableHeader title="Comparison table" />
        <TechnologyAssetsComparisonTable />
    </div>
</template>
<script setup lang="ts">
import TechnologyAssetsComparisonTableHeader from '@/components/TechnologyAssetsComparisonTableHeader.vue';
import TechnologyAssetsComparisonTable from '@/components/TechnologyAssetsComparisonTable.vue';
</script>